import { Modal, StackModalProps } from 'almanac-ui/Modal'
import Styles from './SingleChildModal.module.scss'

interface SingleChildModalProps extends StackModalProps {
  children: React.ReactNode
}

export const SingleChildModal = ({ children }: SingleChildModalProps) => {
  return (
    <Modal.Root size="md" height="inherit">
      <div className={Styles.contentContainer}>{children}</div>
    </Modal.Root>
  )
}
